

export const priceData = [
    {   
        website: "Website",
        solution: "Basic",
        title: "basicWebsite",
        price: "RM8,199.00",
        features:[
            "Design type",
            "Pages",
            "Revision",
            "CRM system",
            "Enquiry form",
            "Stock pictures",
            "Content writing",
            "Domain Fee",
            "Server hosting",
            "Mobile responsive",
            "Website maintenance",
            "Google analytic",
            "Google submission",
            "Google business",
            "Google console",
            <span>Chat Integration <br /> <div className="pl-6 md:pl-7">(Messenger / Whatsapp)</div> </span>,
        ],
        ans: [
            "Template base",
            "5 pages design",
            "X 2",
            "Yes",
            "Unlimited",
            "X 10",
            "Yes",
            "Free",
            "Free",
            "Yes",
            "1st Year free",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
        ],
        combination: "basicWebsiteCombination",
        discount: "-RM1,800.00",
        subtotal: "RM6,399.00",
        ship: "3 - 5",
    },
    {
        website: "Website",
        solution: "Advanced",
        title: "AdvancedWebsite",
        price: "RM18,499.00",
        features:[
            "Design type",
            "Pages",
            "Revision",
            "CRM system",
            "Enquiry form",
            "Stock pictures",
            "Content writing",
            "Domain Fee",
            "Server hosting",
            "Mobile responsive",
            "Website maintenance",
            "Google analytic",
            "Google submission",
            "Google business",
            "Google console",
            <span>Chat Integration <br /> <div className="pl-6 md:pl-7">(Messenger / Whatsapp)</div> </span>,
            "Guarantee 80% text score",
            "Guarantee 80% SEO Checkup score"
        ],
        ans: [
            "Custom",
            "Unlimited",
            "Unlimited",
            "Yes",
            "Unlimited",
            "Unlimited",
            "Free",
            "Free",
            "Free",
            "Yes",
            "Free",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
        ],
        combination: "AdvancedCombination",
        discount: "-RM2,200.00",
        subtotal: "RM16,299.00",
        ship: "4 - 6",
    },
    {
        website: "e-Commerce",
        solution: "Basic",
        title: "basicECommerce",
        price: "RM8,199.00",
        features:[
            "Landing Page",
            "Shopping cart",
            "Revision",
            "CRM system",
            "Max products",
            "Stock pictures",
            "Order management portal",
            "Payment gateway integrate",
            "Enquiry form",
            "Content writing",
            "Domain Fee",
            "Server hosting",
            "Mobile responsive",
            "Website maintenance",
            "Google analytic",
            "Google submission",
            "Google business",
            "Google console",
            <span>Chat Integration <br /> <div className="pl-6 md:pl-7">(Messenger / Whatsapp)</div> </span>,
        ],
        ans: [
            "X 1",
            "Yes",
            "X 2",
            "Yes",
            "X 6",
            "X 6",
            "Yes",
            "Free",
            "Free",
            "Free",
            "Free",
            "Free",
            "Yes",
            "1st year free",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
        ],
        combination: "basicECommerceCombination",
        discount: "-RM1,800.00",
        subtotal: "RM6,399.00",
        ship: "4 - 5",
    },
    {
        website: "e-Commerce",
        solution: "Advanced",
        title: "AdvancedECommerce",
        price: "RM20,899.00",
        features:[
            "Landing Page",
            "Shopping cart",
            "Revision",
            "CRM system",
            "Guest Checkout",
            "Customer Portal",
            "Products & Variations",
            "Stock pictures",
            "Order management portal",
            "Payment gateway integrate",
            "Enquiry form",
            "Content writing",
            "Domain Fee",
            "Server hosting",
            "Mobile responsive",
            "Website maintenance",
            "Blog & article pages",
            "Server database backup",
            "Google analytic",
            "Google submission",
            "Google business",
            "Google console",
            <span>Chat Integration <br /> <div className="pl-6 md:pl-7">(Messenger / Whatsapp)</div> </span>,
        ],
        ans: [
            "Custom",
            "Yes",
            "Unlimited",
            "Yes",
            "Yes",
            "Yes",
            "Unlimited",
            "Unlimited",
            "Yes",
            "Free",
            "Unlimited",
            "Free",
            "Free",
            "Free",
            "Yes",
            "Free",
            "Yes",
            "1st year free",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
            "Yes",
        ],
        combination: "AdvancedECommerceCombination",
        discount: "-RM2,200.00",
        subtotal: "RM18,699.00",
        ship: "5 - 7",
    },
]
